// Discourse form URL are of type https://{domain}/c/{category_name}/{category_id}
// Sample example of discourse form - https://forum.figma.com/c/general/27
// The below regex matches and returns us domain, category name and category id.
const DISCOURSE_FORM_URL_REGEX = /^https:\/\/([^/]+)\/c\/([^/]+)\/(\d+).*$/;

export const getDiscourseFormFieldsFromURL = (formURL: string) => {
  const regexMatchedArray = formURL.match(DISCOURSE_FORM_URL_REGEX);
  if (!regexMatchedArray) {
    return null;
  }

  const [, domain, categoryName, categoryID] = regexMatchedArray;
  return {
    domain,
    categoryID,
    categoryName,
  };
};
